// TODO: more content types
export const getContentSearchCql = (searchText?: string): string => {
	let cql = "type = 'page'";

	if (searchText) {
		cql += ` AND (title ~ '${searchText.replace(/\'/g, '%27')}*'
OR title ~ '${searchText.replace(/\'/g, '%27')}')`;
	}

	cql += ` order by lastModified desc`;

	return cql;
};
